import featuredListingsMarker from 'images/featured_listings_marker.png';
import featuredRentalsMarker from 'images/featured_rentals_marker.png';
import featuredSalesMarker from 'images/featured_sales_marker.png';
import propertyMarker from 'images/property_marker.png';
import {getIn} from 'lib/immutableObject';
import {fitBounds} from 'lib/MapUtil';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import {Component} from 'react';
import './FeaturedComparableMap.scss';

const MAP_WIDTH = 707;
const LEFT_PADDING = 415;
const TARGET_PIXELS_BETWEEN_POINTS = 150;

export default class FeaturedComparableMap extends Component {
  static propTypes = {
    comparableType: PropTypes.oneOf(['sales', 'listings', 'rentals']).isRequired,
    latLng: PropTypes.shape({lat: PropTypes.number.isRequired, lng: PropTypes.number.isRequired}),
    targetLatLng: PropTypes.shape({lat: PropTypes.number.isRequired, lng: PropTypes.number.isRequired}).isRequired,
    center: PropTypes.shape({lat: PropTypes.number.isRequired, lng: PropTypes.number.isRequired}),
    zoom: PropTypes.number,
    markerLabel: PropTypes.string,
    onMapZoomChange: PropTypes.func.isRequired,
    onMapCenterChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const {comparableType, latLng, targetLatLng, center, zoom, markerLabel} = this.props;

    const markerIcon = {
      sales: featuredSalesMarker,
      listings: featuredListingsMarker,
      rentals: featuredRentalsMarker,
    }[comparableType];

    if (latLng && targetLatLng && getIn(window, ['google', 'maps'])) {
      const ourBounds = fitBounds({
        latLng1: latLng,
        latLng2: targetLatLng,
        dimensions: {width: MAP_WIDTH, height: this._mapEl.offsetHeight},
        targetPixelsBetweenPoints: TARGET_PIXELS_BETWEEN_POINTS,
        padding: {left: LEFT_PADDING},
      });
      const map = this._map = new window.google.maps.Map(this._mapEl, {
        center: center || ourBounds.center,
        zoom: zoom || ourBounds.zoom,
        disableDefaultUI: true,
        scaleControl: true,
        zoomControl: true,
        clickableIcons: false,
      });

      this._targetMarket = new window.google.maps.Marker({
        map,
        position: targetLatLng,
        icon: {
          scaledSize: {width: 39, height: 33},
          url: propertyMarker,
        },
      });

      this._featuredMarker = new window.google.maps.Marker({
        map,
        position: latLng,
        icon: {
          scaledSize: {width: 39, height: 33},
          url: markerIcon,
          labelOrigin: {x: 16, y: 13},
        },
        label: this.getLabel(markerLabel),
      });

      if (!center) {
        this.onZoomChanged();
        this.onCenterChanged();
      }

      window.google.maps.event.addListener(map, 'center_changed', this.onCenterChanged);
      window.google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged);
    }
  }

  componentDidUpdate(prevProps) {
    const {markerLabel} = this.props;
    if (this._featuredMarker && markerLabel !== prevProps.markerLabel) {
      this._featuredMarker.setLabel(this.getLabel(markerLabel));
    }
  }

  componentWillUnmount() {
    if(this._map) {
      window.google.maps.event.clearInstanceListeners(this._map);
    }
  }

  getLabel = (markerLabel) => {
    return markerLabel ? {text: markerLabel, color: '#ffffff'} : undefined;
  };

  onCenterChanged = debounce(() => {
    const latLng = this._map.getCenter();
    this.props.onMapCenterChange({lat: latLng.lat(), lng: latLng.lng()});
  }, 500);

  onZoomChanged = debounce(() => {
    this.props.onMapZoomChange(this._map.getZoom());
  }, 500);

  render() {
    const {latLng, targetLatLng} = this.props;

    return (
      <div className="FeaturedComparableMap" ref={(ref) => this._mapEl = ref}>
        {(!latLng || !targetLatLng) && (
          <div className="no-data">This property contains incomplete location data</div>
        )}
      </div>
    );
  }
}
